import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

import { isNull } from 'lodash';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  RadioGroup,
} from '~/components/Form';

import { GFO } from '~/constants/perfil';

import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

function Relaquisicaocombustivelorgaonfentradas() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS

  const [inputValueOrgao, setInputValueOrgao] = React.useState('');
  const [disableOrgao, setDisableOrgao] = useState(false);

  const [valueOrgao, setValueOrgao] = useState({ orga_codigo: '', orga_nome: '' });

  const [orgaNome, setOrgaNome] = React.useState('');

  const [valueProduto, setValueProduto] = useState('');

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (profile.glousuariotipo === GFO) {
        setValueOrgao({ orga_codigo: profile.glousuarioorgacodigo, orga_nome: profile.glousuarioorganome });
        setOrgaNome(profile.glousuarioorganome);
        setDisableOrgao(true);
      }
    }

    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        orga_codigo: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior à data inicial'
          ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  const onSerializeData = useCallback((data) => ({
    ...data,
    orgao: valueOrgao.orga_codigo,
    orgaostr: valueOrgao.orga_nome ? valueOrgao.orga_codigo + ' - ' + valueOrgao.orga_nome : '',
    combustivel: valueProduto.prod_codigo ? valueProduto.prod_codigo : '',
    combustivelstr: valueProduto.prod_descricao ? valueProduto.prod_descricao : '',
    produto: valueProduto.prod_codigo ? valueProduto.prod_codigo : '',
    produtostr: valueProduto.prod_descricao ? valueProduto.prod_descricao : '',
  }))

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Aquisição Combustível Órgão – NF Entradas"
      relatorio="AQUISICAOCOMBUSTIVELORGAONFENTRADAS"
      validate={(param) => handleValidate(param)}
      serialize={onSerializeData}
      initials={{
        datahorainicial,
        datahorafinal,
        orga_codigo: valueOrgao.orga_codigo,
      }}
    >
      <DateTime
        time
        label="Data Inicial"
        name="datahorainicial"
        disableFuture={true}
      />

      <DateTime
        time
        label="Data Final"
        name="datahorafinal"
        disableFuture={true}
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      />

      <Autocomplete
        name="orga_codigo"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"        
        inputValue={valueOrgao !== undefined ? valueOrgao.orga_nome : ''}
        onInputChange={(event, value) => {
          let obj = {
            ...valueOrgao,
            orga_nome: value,
          }
          setValueOrgao(obj);
        }}        
        hiddens={[{ name: 'orga_nome' }]}
        getValue={(value) => {
          if (isNull(value.orga_nome)) setValueOrgao({ orga_codigo: '', orga_nome: '' });
          else setValueOrgao(value);          
        }}
        disabled={disableOrgao}
      />

      <Autocomplete
        name="produto"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        getValue={(value) => setValueProduto(value)}
      />

      <RadioGroup
        name="tipo"
        label="Tipo"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relaquisicaocombustivelorgaonfentradas;
